// 作业备案首页
<template>
	<div>
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
	</div>
</template>
<script>
	export default {
		data() {
			return {};
		},
		created() {},
		methods: {},
	};
</script>
